<div class="flex h-full flex-col">
  <!-- SwUpdate available notification -->
  @if (swUpdateService.swUpdateAvailable() && !hideUpdateBanner()) {
  <p-message severity="warn" icon="pi pi-exclamation-triangle">
    <div class="flex w-full flex-col gap-1 sm:flex-row sm:items-center" data-sentry-unmask>
      <span>A new version of Isla is ready!</span>
      <button
        (click)="reloadPage()"
        class="button-reset interactive-link text-text-warning underline"
        aria-label="Refresh the page"
      >
        Refresh the page
      </button>
      <span>to get the latest improvements.</span>
    </div>
  </p-message>
  }

  <!-- SwUpdate error notification -->
  <!-- Temporary disabled while the Service Worker issue is investigated (OET-932) -->
  @if (swUpdateService.swUpdateError() && !hideUpdateBanner()) {
  <p-message severity="error" icon="pi pi-times-circle">
    <div class="flex w-full flex-col gap-1 sm:flex-row sm:items-center" data-sentry-unmask>
      <span>We encountered an issue while updating.</span>
      <button
        (click)="reloadPage()"
        class="button-reset interactive-link text-error underline"
        aria-label="Refresh the page"
      >
        Refresh the page
      </button>
      <span>to try again.</span>
    </div>
  </p-message>
  }

  <!-- Browser support check -->
  @if (systemCheckService.browserIsIE11()) {
  <div class="flex flex-col items-center justify-center pt-20" data-sentry-unmask>
    <span class="text-2xl font-semibold">Unsupported browser</span>
    <p>
      Your current browser is not supported. Please use a modern, up-to-date browser to access all features and ensure
      the best security.
    </p>
  </div>
  } @else {
  <!-- Main content -->
  <div class="min-h-0 flex-1">
    <ng-content></ng-content>
  </div>
  }
</div>
